export default __webpack_public_path__ + "locales/nl/EmptyView.json?hash=245a5fa43fa3ce628e46968ba3812a18";